import { Box, Typography } from "@mui/material";

export const NotFoundPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <Box
        component="img"
        src="/404.webp"
        alt="404 Not Found"
        sx={{
          maxWidth: "100%",
          maxHeight: "50vh",
          objectFit: "contain",
          m: 4,
        }}
      />
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "text.secondary",
        }}
      >
        Page Not Found
      </Typography>
    </Box>
  );
};
